import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

/**
 * DataRetentionApi
 * Admin endpoints for managing data retention and cleanup
 */
export const DataRetentionApi = {
  /**
   * Get data retention status
   * Returns retention configuration and count of records pending cleanup
   */
  getStatus: async () => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/admin/data-retention/status`, {
      method: 'GET',
    });
  },

  /**
   * Execute data retention cleanup
   * Deletes records older than configured retention period
   * Requires admin role
   */
  executeCleanup: async () => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/admin/data-retention/cleanup`, {
      method: 'POST',
    });
  },

  /**
   * Get cleanup execution history
   * Returns recent cleanup operations
   * 
   * @param {number} limit - Maximum number of records (default: 10)
   */
  getCleanupHistory: async (limit = 10) => {
    const url = `${DATA_SERVICE_BASE_URL}/api/admin/data-retention/history?limit=${limit}`;
    return fetchWithAuth(url, {
      method: 'GET',
    });
  },
};
